<template>
  <div>
    <h4 class="tab__content__title">Основная информация</h4>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.PROJECT_NAME }}:</span>
      <span class="stack__value break-words">{{ application.name }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.ADDITIONAL_EXPERTISE }}:</span>
      <span class="stack__value">{{application.additionalExpertise.map((item) => $lang.$translate({ ru: item.nameRu, kg: item.nameKg })).join(", ") }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.CONSTRUCTION_TYPE }}:</span>
      <span class="stack__value">{{ $lang.$translate({ ru: application.constructionType?.nameRu, kg: application.constructionType?.nameKg }) }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.PURPOSE_OF_OBJECT }}:</span>
      <span class="stack__value">{{ $lang.$translate({ ru: application.appointment?.nameRu, kg: application.appointment?.nameKg }) }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.OBJECT_POSTAL_ADDRESS }}:</span>
      <span class="stack__value">{{ application.address?.address }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.EXPERTIZE_PAYMENT_SOURCE }}:</span>
      <span class="stack__value">{{ application.paymentSourceTxt }}</span>
    </div>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.OWNERSHIP_FORM }}:</span>
      <span class="stack__value">{{ $lang.app[ownershipTypesGetLabelRefByValue(application.ownership)] }}</span>
    </div>
    <template v-if="application.locationType">
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.OBJECT_CATEGORY }}:</span>
        <span class="stack__value">{{ $lang.$translate({ru: application.locationType.category.nameRu, kg: application.locationType.category.nameKg}) }}</span>
      </div>
      <div class="stack__list">
        <span class="stack__label">{{ $lang.app.OBJECT_TYPE }}:</span>
        <span class="stack__value">{{ $lang.$translate({ru: application.locationType.nameRu, kg: application.locationType.nameKg}) }}</span>
      </div>
    </template>
    <div class="stack__list">
      <span class="stack__label">{{ $lang.app.OBJECT_IS_STRATEGIC }}</span>
      <span class="stack__value">{{ application.isStrategic ? $lang.app.YES : $lang.app.NO }}</span>
    </div>
  </div>
</template>
<script>
import {getLabelRefByValue as ownershipTypesGetLabelRefByValue} from "../../../helpers/constants/ownershipTypes";

export default {
  props: {
    application: Object
  },
  methods: {
    ownershipTypesGetLabelRefByValue
  }
}
</script>
